module.exports = __webpack_public_path__ + "media/images/emblems/Haut-Intyamon-coat_of_arms-941e69bb8f29825e58070f6e90456335.svg";